module.exports = __WEBPACK_EXTERNAL_MODULE__mfe_mfe_statistics_remoteEntry_mjs_75c4e822__;